"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetType = void 0;
exports.DatasetType = {
    EmbedInput: "embed-input",
    EmbedResult: "embed-result",
    ClusterResult: "cluster-result",
    ClusterOutliers: "cluster-outliers",
    RerankerFinetuneInput: "reranker-finetune-input",
    PromptCompletionFinetuneInput: "prompt-completion-finetune-input",
    SingleLabelClassificationFinetuneInput: "single-label-classification-finetune-input",
    ChatFinetuneInput: "chat-finetune-input",
    MultiLabelClassificationFinetuneInput: "multi-label-classification-finetune-input",
};
